module.exports = __webpack_public_path__ + "static/img/crane-placeholder.d844ea3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/crane-placeholder.png
// module id = 327
// module chunks = 1